// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Experience-module--bx--text-truncate--end--3px2z";
export var bxTextTruncateFront = "Experience-module--bx--text-truncate--front--23tw-";
export var experience = "Experience-module--experience--3kfkZ";
export var experienceContainer = "Experience-module--experience-container--1aMnS";
export var selected = "Experience-module--selected--1YgJd";